import "@fortawesome/fontawesome-free/css/all.css"
import "./index.scss"
import "bootstrap"
import React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { AccessGuard } from "./component/guard/AccessGuard"
import { CommonProvider } from "./component/CommonProvider"
import { createRoot } from "react-dom/client"
import { Top } from "./pages/Top"
import { My } from "./pages/My"
import { User } from "./pages/User"
import { Space } from "./pages/Space"
import { Live } from "./pages/Live"
import { Selection } from "./pages/Selection"
import { OAuthVirtualCastCallback } from "./pages/OAuthVirtualCastCallback"
import { Home } from "./pages/Home"
import { Notifications } from "./pages/Notifications"
import { Shop } from "./pages/Shop"
import { TRTCTester } from "./pages/TRTCTester"
import { Items } from "./pages/Items"
import { Item } from "./pages/Item"
import { Stories } from "./pages/Stories"
import { Voices } from "./pages/Voices"
import { RecommendedUsers } from "./pages/RecommendedUsers"
import { ViolationReport } from "./pages/ViolationReport"
import { PublicLanding } from "./pages/PublicLanding"
import { ProxyRedirect } from "./pages/ProxyRedirect"
import { NotFound } from "./pages/NotFound"
import { DebugError } from "./pages/DebugError"
import { DotMoney } from "./pages/DotMoney"
import { Paths } from "./paths"


const root = (
  <BrowserRouter>
    <CommonProvider>
      <Routes>
        {/* Public-facing pages for SSR with locale support */}
        {/* All public pages use the same interstitial landing page */}
        <Route path={Paths.ja.users.user.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.users.user.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.users.user.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.users.user.follow.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.users.user.follow.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.users.user.follow.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.spaces.space.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.spaces.space.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.spaces.space.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.spaces.space.lives.live.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.spaces.space.lives.live.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.spaces.space.lives.live.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.items.item.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.items.item.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.items.item.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.customTags.customTag.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.customTags.customTag.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.customTags.customTag.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.brands.brand.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.brands.brand.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.brands.brand.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.collections.collection.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.collections.collection.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.collections.collection.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.invites.friends.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.invites.friends.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.invites.friends.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.invites.spaces.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.invites.spaces.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.invites.spaces.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.premium.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.premium.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.premium.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.notifications.system.notification.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.notifications.system.notification.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.notifications.system.notification.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.notifications.system.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.notifications.system.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.notifications.system.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.notifications.personal.notification.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.notifications.personal.notification.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.notifications.personal.notification.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.notifications.personal.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.notifications.personal.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.notifications.personal.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.shop.search.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.shop.search.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.shop.search.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.top.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.top.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.top.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.inventory.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.inventory.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.inventory.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.stampCards.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.stampCards.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.stampCards.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.stampCards.stampCard.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.stampCards.stampCard.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.stampCards.stampCard.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.histories.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.histories.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.histories.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.following.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.following.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.following.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.my.notifications.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.my.notifications.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.my.notifications.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.news.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.news.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.news.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.about.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.about.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.about.path} element={<PublicLanding/>}/>

        <Route path={Paths.ja.contact.path} element={<PublicLanding/>}/>
        <Route path={Paths.en.contact.path} element={<PublicLanding/>}/>
        <Route path={Paths.ko.contact.path} element={<PublicLanding/>}/>

        {/* VirtualCast OAuth コールバック — AccessGuard の外に配置。ユニバーサルリンクのフォールバック */}
        <Route path={Paths.debug.oauth.virtualcast.callback.path} element={<PublicLanding/>}/>

        {/* Debug routes - all existing functionality moved under /debug */}
        <Route path={Paths.debug.trtcTester.path} element={<TRTCTester/>}/>
        <Route path={Paths.debug.error.path} element={<DebugError/>}/>
        <Route element={<AccessGuard/>}>
          <Route path={Paths.debug.top.path} element={<Top/>}/>
          <Route path={Paths.debug.home.path} element={<Home/>}/>
          <Route path={Paths.debug.notifications.path} element={<Notifications/>}/>
          <Route path={Paths.debug.shop.path} element={<Shop/>}/>
          <Route path={Paths.debug.my.path} element={<My/>}/>
          <Route path={Paths.debug.items.path} element={<Items/>}/>
          <Route path={Paths.debug.items.item.path} element={<Item/>}/>
          <Route path={Paths.debug.users.user.path} element={<User/>}/>
          <Route path={Paths.debug.spaces.space.path} element={<Space/>}/>
          <Route path={Paths.debug.spaces.space.lives.live.path} element={<Live/>}/>
          <Route path={Paths.debug.spaces.space.lives.live.selections.selection.path} element={<Selection/>}/>
          <Route path={Paths.debug.oauth.virtualcast.callback.path} element={<OAuthVirtualCastCallback/>}/>
          <Route path={Paths.debug.stories.path} element={<Stories/>}/>
          <Route path={Paths.debug.voices.path} element={<Voices/>}/>
          <Route path={Paths.debug.recommendedUsers.path} element={<RecommendedUsers/>}/>
          <Route path={Paths.debug.violationReport.path} element={<ViolationReport/>}/>
          <Route path={Paths.debug.dotMoney.path} element={<DotMoney/>}/>
        </Route>
        {/* Top page and /about - proxied from product site by Cloud Function */}
        {/* ProxyRedirect handles client-side rendering by redirecting to ?from=web */}
        <Route path="/" element={<ProxyRedirect/>}/>
        <Route path="/about" element={<ProxyRedirect/>}/>
        {/* Fallback - 404 page */}
        <Route path="*" element={<NotFound/>}/>
      </Routes>
    </CommonProvider>
  </BrowserRouter>
)

const doc = document.getElementById("screen");
if (doc === null) {
  console.error("screen is null!")
} else {
  createRoot(doc).render(root)
}
